import moment from "moment";
export const state = {
  lancamentoCaixa: {
    forma_pagamento_id: "",
    forma_pagamento: "",
    valor: "",
    tipo: "",
    historico: "",
    data: moment().format("YYYY-MM-DD"),
  },
  lancamentosCaixa: [],
  modalCadastroLancamentoCaixa: false,
  modalExcluirLancamentoCaixa: false,
  modalRelatorioFechamentoCaixa: false,
  modalListarLancamentoCaixa: false,
  formaPagamentoSelecionadaLancamentoCaixa: {},
  lacamentoCaixaTipos: [
    "SANGRIA",
    "DESPESAS DIVERSAS",
    "RECEBIMENTOS DIVERSOS",
    "FUNDO DE CAIXA/SUPRIMENTO",
    "COLETA",
  ],
};

export default {};
